export default __webpack_public_path__ + "static/cp-hero-d96285dd5e0ac66aea40c9616c45fbad.mp4";